require('./_colorbox.scss');

(function ($) {
    $(function () {

        $(document).on("click", "*[data-toggle=hyperlink]", function () {
            window.open($(this).data("targetUrl"), "_blank");
        });

        $(document).on("click", "*[data-toggle='lightbox']", function () {
            let $this = $(this);
            let url = $this.data("target-url");
            let width = $this.data("lightbox-width")
                ? $this.data("lightbox-width")
                : "800px";
            let height = $this.data("lightbox-height")
                ? $this.data("lightbox-height")
                : "600px";

            let isId = url.indexOf("#") === 0;

            $.colorbox({
                href: url,
                iframe: !isId,
                inline: isId,
                width: width,
                height: height,
                opacity: 0.95,
                fixed: true
            });
        });
    });

    $(document)
        .bind("cbox_complete",
            function () {
                $("body").addClass("fixed");
            })
        .bind("cbox_cleanup",
            function () {
                $("body").removeClass("fixed");
            });
})(jQuery);
